import { isUploadMethod } from "@/hooks/uploads/uploadMethodsConfig";
import type { KnowledgeBaseRouteIntent } from "@/types/knowledge/knowledge-acquisition";

export const resolveKnowledgeBaseRouteIntent = (
  searchParams: URLSearchParams,
): KnowledgeBaseRouteIntent => {
  const acquireParam = searchParams.get("acquire");
  const tabParam = searchParams.get("tab");
  const directMethod = isUploadMethod(acquireParam) ? acquireParam : null;
  const legacyMethod =
    tabParam === "cloud-storage" ? "cloud-storage" : tabParam === "upload" ? "pdf" : null;

  return {
    uploadMethod: directMethod ?? legacyMethod,
    shouldCleanAcquireParam: directMethod !== null,
    shouldCleanLegacyTabParam: legacyMethod !== null,
  };
};
